const state = {
  copyMode: 'url'
}

const mutations = {
  SET_COPY_MODE(state, mode) {
    state.copyMode = mode
  }
}

export default {
  namespaced: true,
  state,
  mutations
}